import React from 'react';
import { Link } from 'react-router-dom';

function Header() {
  return (
    <header className="bg-white shadow-sm">
      {/* Top Bar with Logo and Phone */}
      <div className="container flex items-center justify-between px-4 md:px-6 py-2 md:py-3 mx-auto">
        <div className="flex items-center">
          <Link to="/" className="flex items-center space-x-2 md:space-x-3">
            <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 md:w-10 md:h-10 text-orange-500" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
            </svg>
            <span className="text-xl md:text-2xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-orange-600">
              EzzyDental
            </span>
          </Link>
        </div>
        <div className="items-center hidden space-x-2 md:flex">
          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-orange-500" viewBox="0 0 20 20" fill="currentColor">
            <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z"/>
          </svg>
          <a href="tel:888.222.3232" className="text-lg md:text-xl font-bold text-[#1E2A4A] hover:text-orange-500 transition-colors">
            888.222.3232
          </a>
        </div>
      </div>
    </header>
  );
}

export default Header; 